import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { GenericResponse } from 'src/app/shared/interfaces/generic.interface';
import { AccessService } from 'src/app/core/services/access.service';
import { environment as env } from 'src/environments/environment';
import {
  Approver,
  AttendanceList,
  DataDatailRequest,
  DataScheduleByUser,
  DataUpdateAssistance,
  ExtensionTardinessItem,
  MarkHistory,
  dataGeneralFooter,
} from '../interfaces/attendance.interface';
import { AttendanceMonthly } from '../../../my-board/interfaces/board.interfaces';
import { Observable, of } from 'rxjs';
import { GenericResponseList } from 'src/app/shared/interfaces/table.interface';
import {
  setDataForJustifications,
  setDataGeneralFooterAttendaceList,
  transforDataAttendaceList,
} from '../helpers/mapDataAttendanceList';
import { TableService } from 'src/app/shared/helpers/list-table';

import { REFRESH_INDEXED } from 'src/app/core/indexedDB/helpers/enums.enums';

import { IndexedDBDexieService } from 'src/app/core/indexedDB/service/indexed-db-dexie.service';
import { localDB } from 'src/app/shared/helpers/localStorage';

@Injectable({
  providedIn: 'root',
})
export class AttendanceService implements TableService {
  constructor(
    private readonly _http: HttpClient,
    private readonly _accessService: AccessService,
    private readonly _indexDB: IndexedDBDexieService
  ) { }

  getAll(
    records: number,
    sort: string,
    order: string,
    numPage: number,
    getInputs = '',
    baseUrl: string
  ) {
    let modifiedInputs = getInputs;
    const matchF7 = modifiedInputs.match(/sFilterSeven=([^&]*)/);
    if (matchF7) {
      const value = matchF7[1];
      if (value === 'null' || value === '') {
        modifiedInputs = modifiedInputs.replace(/sFilterSeven=[^&]*/, 'sFilterSeven=0');
      } else {
        const selected = value.split('-');
        if (selected.length === 6) {
          modifiedInputs = modifiedInputs.replace(/sFilterSeven=[^&]*/, 'sFilterSeven=null');
        }
      }
    } else if (!modifiedInputs.includes('sFilterSeven=')) {
      modifiedInputs += '&sFilterSeven=0';
    }
    const requestUrl = `${env.api_url}api/asistencias/listar?records=${records}&sort=${sort}&order=${order}&numPage=${numPage + 1}${modifiedInputs}`;
    return this._http.get<GenericResponseList<AttendanceList>>(requestUrl).pipe(
      map((response) => {
        return transforDataAttendaceList(response, modifiedInputs, this._accessService);
      })
    );
  }

  getFooter(getInputs: string): Observable<GenericResponse<dataGeneralFooter>> {
    const requestUrl = `${env.api_url}api/asistencias/listarTotalGeneral?${getInputs}`;
    return this._http.get<GenericResponse<dataGeneralFooter>>(requestUrl).pipe(
      map((response) => {
        return setDataGeneralFooterAttendaceList(response);
      })
    );
  }

  getdetailRequest(idColaborador: number, fecha: string | Date) {
    return this._http.get<GenericResponse<DataDatailRequest[]>>(
      `${env.api_url}api/asistencias/solicitudesDetalle?dFecha_Asistencia=${fecha}&nId_Colaborador=${idColaborador}`
    );
  }

  getExtensionsAndTardiness(idColaborador: number, fecha: string | Date) {
    return this._http.get<GenericResponse<ExtensionTardinessItem[]>>(
      `${env.api_url}api/asistencias/extensionesTardanzas?dFecha_Asistencia=${fecha}&nId_Colaborador=${idColaborador}`
    );
  }

  hasAttendance(idColaborador: number, fecha: string | Date) {
    return this._http.get<GenericResponse<boolean>>(
      `${env.api_url}api/asistencias/hasAttendance?dFecha_Asistencia=${fecha}&nId_Colaborador=${idColaborador}`
    );
  }

  getListMarkings(fecha: string, sendLocaldb: boolean = false, idColaborador: number) {
    const url = `${env.api_url}api/marcas/get-marks-created?nid_colaborador=${idColaborador}&dfecha_jornada=${fecha}&bIsExtemp=${false}`
    return this._http.get<any>(url).pipe(
      map(res => {
        if (sendLocaldb) {
          localDB.removeItem('marks-user');
          localDB.setItem('marks-user', JSON.stringify(res))
        }
        return res
      })
    );
  }

  getMissingMarksStatus(dLastClosureDate: string, nId_Colaborador: string | number) {
    const payload = {
      dLastClosureDate: dLastClosureDate,
      nId_Colaborador: Number(nId_Colaborador)
    };

    return this._http.post<any>(`${env.api_url}api/marcas/marks-status`, payload);
  }

  updateStateAssistanceMassive(data: {
    dFecha_Inicio: string;
    dFecha_Fin: string;
    nId_User?: number | null;
  }) {
    return this._http.post<GenericResponse<DataUpdateAssistance>>(
      `${env.api_url}api/asistencias/actualizarMasivo`,
      data
    );
  }

  updateAssitanceWithRequest(data: any) {
    const endpoint =
      env.api_url + 'api/solicitud/crear';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data; charset=utf-8');
    return this._http.post<GenericResponse<DataUpdateAssistance>>(
      endpoint,
      data,
      { headers }
    );
  }

  myAssistanceMonthly() {
    const request = 'api/asistencias/AsistenciaDelMes'
    return this._indexDB.getRequestData<GenericResponse<AttendanceMonthly>>(request, 'endpoints', REFRESH_INDEXED.EVERY_DAY)
  }

  gerListAssitanceHistory(nIdAsistencia: number) {
    return this._http.get<GenericResponse<MarkHistory[]>>(
      `${env.api_url}api/asistencias/AsistenciaHistorico/listar?nIdAsistencia=${nIdAsistencia}`
    );
  }

  getMarkJustify(registrationDate: string, nId_Colaborador: number) {
    return this._http.get<any>(
      `${env.api_url}api/asistencias/AsistenciasJustificaciones/listar?dFecha_Asistencia=${registrationDate}&nId_Colaborador=${nId_Colaborador}`
    ).pipe(
      map((response) => {
        return setDataForJustifications(response);
      })
    )
  }

  //FROM REQUEST
  getScheduleByUser(idUsuario: number): Observable<any> {
    let nId_Usuario = localDB.getItem('idUsuario');
    if (nId_Usuario === idUsuario.toString()) {
      return this._indexDB.getRequestData<GenericResponse<DataScheduleByUser>>('api/horario/obtenerHorario?nId_User=', 'endpoints', REFRESH_INDEXED.EVERY_DAY, { query: idUsuario.toString() });
    } else {
      const request = env.api_url + 'api/horario/obtenerHorario?nId_User=' + idUsuario.toString();
      return this._http.get<any>(request).pipe(
        catchError((err: any) => {
          console.log(err);
          return of(null);
        })
      )
    }
  }

  getApprovers(): Observable<GenericResponse<Approver>> {
    return this._indexDB.getRequestData<GenericResponse<Approver>>('api/solicitud/futuro-aprobador', 'endpoints', REFRESH_INDEXED.EVERY_DAY)
  }
}